var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoginName)?_c('div',[_c('div',{staticClass:"text-lg-h6 text-md-h6 text-sm-h6 text-xs-h6 darken-3 mb-4 text-center"},[_vm._v(" "+_vm._s(_vm.curTabItem["name"])+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }